export interface IClcTargetDecline {
     id: number;
     offerDate: string;
     recipientAlias: string;
     donorAlias: string;
     decisionDate: string;
     adjustment: number;
}